
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import LoginImage from '../images/sign-in-image.png';

export default function LoginImageBlock() {
  const LoginImageBlock = (
    <Box>
      <img src={LoginImage} alt="Login Graph" className='img-fluid' />      
    </Box>
  ); 
  return <RouterLink to="/">{LoginImageBlock}</RouterLink>;
}
